import { ONE_SECOND_IN_MILLISECONDS } from '@space-shell/constant/time'

import { NumberUtils } from '../number'

class TimeUtils {
  static formatToMinuteAndSecond(timeInSeconds: number) {
    const oneMinuteInSec = 60
    const finalSize = 2
    const minutes = Math.floor(timeInSeconds / oneMinuteInSec)
    const seconds = timeInSeconds % oneMinuteInSec

    return `${NumberUtils.completeNumberWithLeftZero(
      minutes,
      finalSize
    )}:${NumberUtils.completeNumberWithLeftZero(seconds, finalSize)}`
  }

  static formatTimestamp(timestamp: number) {
    const date = new Date(timestamp * ONE_SECOND_IN_MILLISECONDS)

    const formattedDate = date.toLocaleString('pt-BR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
      timeZone: 'America/Sao_Paulo' // GMT-0300
    })

    return formattedDate.replace(
      /(\d{2})\/(\d{2})\/(\d{4}),\s(\d{2}):(\d{2}):(\d{2})/,
      '$3-$2-$1 $4:$5:$6'
    )
  }
}

export default TimeUtils
